// @flow
import get from 'lodash/get';
import type { ResponseSearchAds } from '../../types/responseSearchAds';
import geoOsmMapper from './common/geoOsmMapper';
import interlinkingMapper from './common/interlinkingMapper';

export default function map(payload: Object): ResponseSearchAds {
  const { verticalName, responseData } = payload;
  const { keyword, meta } = responseData;

  return {
    keyword: keyword && {
      redirectWhat: keyword.redirectWhat,
      redirectWhere: keyword.redirectWhere,
      hasResults: !keyword.empty,
      searchTerms: {
        what: keyword.what || '',
        whatDirified: keyword.url,
        whatSearch: keyword.whatSearch,
        where: keyword.where || '',
        didYouMeanWhat: keyword.didYouMeanWhat,
      },
      location: {
        region: keyword.region,
        city: keyword.city,
        cityArea: keyword.cityArea,
      },
      geoOsm: geoOsmMapper(get(keyword, 'geoInfo')),
      interlinking: interlinkingMapper(keyword),
      verticalProperties: {
        verticalName,
        cars: {
          make: keyword.make,
          model: keyword.model,
        },
        products: {
          categoryTypeId: keyword.categoryTypeId,
        },
      },
    },
    meta: meta && {
      title: meta.title,
      description: meta.description,
      pagination: {
        currentPage: meta.pagination.page,
        maxPage: meta.pagination.maxPage,
        currentPageUrl: meta.pagination.self,
        previousPageUrl: meta.pagination.previous,
        nextPageUrl: meta.pagination.next,
        lastPageUrl: meta.pagination.last,
      },
      filters: {
        // TODO: Apis must give us a list with the possible auto filters, until then, we use directly the field that return us the api
        auto: meta.filters.auto,
        user: {
          homes: {
            areaMax: meta.filters.user.areaMax,
            areaMin: meta.filters.user.areaMin,
            bathroomsMin: meta.filters.user.bathroomsMin,
            region: meta.filters.user.region,
            city: meta.filters.user.city,
            cityArea: meta.filters.user.cityArea,
            dateFrom: meta.filters.user.dateFrom,
            decreasePrice: meta.filters.user.decreasePrice,
            geoId: meta.filters.user.geoId,
            latMax: meta.filters.user.latMax,
            latMin: meta.filters.user.latMin,
            longMax: meta.filters.user.longMax,
            longMin: meta.filters.user.longMin,
            newBuild: meta.filters.user.newBuild,
            parking: meta.filters.user.parking,
            photos: meta.filters.user.photos,
            priceMax: meta.filters.user.priceMax,
            priceMin: meta.filters.user.priceMin,
            propertyType: meta.filters.user.propertyType,
            roomsMin: meta.filters.user.roomsMin,
          },
          cars: {
            region: meta.filters.user.region,
            city: meta.filters.user.city,
            carType: meta.filters.user.carType,
            dateFrom: meta.filters.user.dateFrom,
            decreasePrice: meta.filters.user.decreasePrice,
            doorsMax: meta.filters.user.doorsMax,
            doorsMin: meta.filters.user.doorsMin,
            fuel: meta.filters.user.fuel,
            geoId: meta.filters.user.geoId,
            make: meta.filters.user.make,
            mileageMax: meta.filters.user.mileageMax,
            mileageMin: meta.filters.user.mileageMin,
            model: meta.filters.user.model,
            photos: meta.filters.user.photos,
            priceMax: meta.filters.user.priceMax,
            priceMin: meta.filters.user.priceMin,
            transmission: meta.filters.user.transmission,
            yearMax: meta.filters.user.yearMax,
            yearMin: meta.filters.user.yearMin,
          },
          products: {
            region: meta.filters.user.region,
            city: meta.filters.user.city,
            dateFrom: meta.filters.user.dateFrom,
            decreasePrice: meta.filters.user.decreasePrice,
            latMax: meta.filters.user.latMax,
            latMin: meta.filters.user.latMin,
            longMax: meta.filters.user.longMax,
            longMin: meta.filters.user.longMin,
            photos: meta.filters.user.photos,
            priceMax: meta.filters.user.priceMax,
            priceMin: meta.filters.user.priceMin,
          },
          jobs: {
            region: meta.filters.user.region,
            city: meta.filters.user.city,
            cityArea: meta.filters.user.cityArea,
            dateFrom: meta.filters.user.dateFrom,
            salaryMin: meta.filters.user.salaryMin,
            salaryMax: meta.filters.user.salaryMax,
            category: meta.filters.user.category,
            company: meta.filters.user.company,
            jobType: meta.filters.user.jobType,
            workingHours: meta.filters.user.workingHours,
            experienceMax: meta.filters.user.experienceMax,
            experienceMin: meta.filters.user.experienceMin,
            telecommute: meta.filters.user.telecommute,
            latMin: meta.filters.user.latMin,
            latMax: meta.filters.user.latMax,
            longMin: meta.filters.user.longMin,
            longMax: meta.filters.user.longMax,
          },
        },
      },
    },
  };
}



// WEBPACK FOOTER //
// ./app/Serp/mappers/apiSearchResponse/responseMapper.js